import { CateringTranslations } from "./catering-pt-br";

export const CATERING_ES_MX: CateringTranslations = {
	title: "Catering",
	description:
		"Gestiona el catering de tus eventos, recibe propuestas, envía cotizaciones y monitorea todo en un solo lugar.",
	createProposal: "Crear propuesta",
	createProposalMenu: {
		new: "Nueva",
		fromTemplate: "Desde una plantilla",
	},
	proposalsList: {
		filters: {
			searchPlaceholder: "Buscar por nombre del representante o remitente",
			statusPlaceholder: "Todos los estatus",
		},
		actions: {
			ariaLabel: "Acciones de la propuesta",
			viewEdit: "Ver / Editar propuesta",
			view: "Ver propuesta",
			saveAsTemplate: "Guardar como plantilla",
			download: "Descargar propuesta",
			resend: "Reenviar propuesta",
			delete: "Eliminar",
		},
		confirmDelete: {
			title: "Eliminar propuesta",
			message:
				"¿Estás seguro de que deseas eliminar esta propuesta? Esta acción no se puede deshacer.",
			confirm: "Eliminar",
		},
		feedback: {
			resendSuccess: "Propuesta reenviada correctamente.",
			downloadError: "No se pudo descargar el PDF.",
			deleteSuccess: "Propuesta eliminada correctamente.",
		},
	},
	createProposalPage: {
		title: "Nueva propuesta",
		sidebarSummary: {
			client: "Cliente",
			duration_one: "{{count}} día de duración",
			duration_other: "{{count}} días de duración",
			totalLabel: "Inversión total",
			servicesCount_one: "{{count}} servicio",
			servicesCount_other: "{{count}} servicios",
			perParticipant: "{{value}} por participante",
			perDay: "{{value}} por día",
		},
		saveAndAdvance: "Guardar y continuar",
		notifications: {
			createSuccess: "¡Propuesta creada con éxito!",
			updateSuccess: "¡Propuesta actualizada con éxito!",
		},
		steps: {
			requestDetails: {
				label: "Detalles de la solicitud",
				action: "Identifica la propuesta",
				title: "Detalles de la solicitud",
				description:
					"Captura los datos de identificación del solicitante de la propuesta.",
				fields: {
					name: {
						label: "Nombre de la propuesta",
						placeholder: "Captura el nombre de la propuesta",
					},
					observation: {
						label: "Observación (opcional)",
						placeholder: "Ej.: Contratación mínima de 50 pax.",
						counter: "{{count}}/{{max}} caracteres",
					},
					companyName: {
						label: "Empresa solicitante",
						placeholder: "Captura el nombre de la empresa / cliente",
					},
					representativeName: {
						label: "Representante de la empresa",
						placeholder: "Captura el nombre del representante",
					},
					eventPeriod: {
						label: "Período de realización del evento",
						placeholder: "DD/MM/AA - DD/MM/AA",
					},
				},
				validation: {
					name: { required: "Captura el nombre de la propuesta" },
					companyName: { required: "Captura la empresa solicitante" },
					representativeName: { required: "Captura el representante de la empresa" },
					eventPeriod: {
						required: "Captura el período del evento",
						future: "Las fechas deben estar en el futuro",
						endBeforeStart: "La fecha final debe ser mayor o igual a la inicial",
					},
					observation: { max: "Máximo de {{max}} caracteres" },
				},
			},
			services: {
				label: "Servicios",
				action: "Agrega servicios y productos",
				title: "Servicios",
				description: "Agrega los servicios y productos de la propuesta.",
				priceUpdates: {
					alert: {
						title:
							'Propuesta creada a partir de la plantilla "[Nombre de la plantilla]".',
						message:
							"Algunos precios fueron actualizados desde la creación de esta propuesta. Revisa los valores antes de enviar.",
						link: "Ver productos actualizados",
					},
					modal: {
						title: "Productos actualizados",
						intro:
							"Algunos productos cambiaron de precio desde la creación de esta propuesta. Revisa los valores antes de enviar.",
						sectionTitle: "Productos modificados",
						removed: "Producto eliminado",
						confirm: "Entendido",
					},
				},
				emptyState: {
					title: "Aún no hay servicios agregados",
					description: "Usa la barra de búsqueda para encontrar productos",
					action: "Agregar",
				},
				list: {
					counter: "Servicios agregados ({{count}})",
					add: "Agregar",
					total: "Total {{value}}",
					totalCount: "/ {{count}} servicios",
					fallbackTitle: "Servicio",
					actions: {
						reorder: "Reordenar servicio",
						edit: "Editar",
						duplicate: "Duplicar",
						delete: "Eliminar",
					},
					itemsCount: "{{count}} ítems",
					periodsCount: "{{count}} períodos",
					notifications: {
						added: "Servicio agregado",
						updated: "Servicio actualizado",
						removed: "Servicio eliminado",
						duplicated: "Servicio duplicado",
					},
					confirmDelete: {
						title: "Eliminar servicio",
						message:
							"¿Estás seguro que deseas eliminar este servicio? Esta acción no se puede deshacer.",
						messageWithName:
							'¿Estás seguro que deseas eliminar "{{name}}"? Esta acción no se puede deshacer.',
						confirm: "Eliminar",
					},
				},
				drawer: {
					title: "Nuevo servicio",
					editTitle: "Editar servicio",
					steps: {
						info: { label: "Información" },
						products: { label: "Productos" },
					},
					actions: {
						advance: "Avanzar",
						back: "Volver",
						save: "Guardar",
						summary: "{{count}} ítems",
					},
					products: {
						title: "Agrega productos",
						searchPlaceholder: "Buscar un producto o combo",
						perPax: "/pax",
						empty: "No se encontraron productos.",
						minSelectionError: "Debes seleccionar al menos 1 producto",
						scrollPrev: "Categorías anteriores",
						scrollNext: "Próximas categorías",
						categories: {
							all: "Todos",
							food: "Comidas",
							drink: "Bebidas",
							combo: "Combos",
						},
					},
					mountable: {
						title: "Elige las opciones",
						sectionCounter: "{{current}} de {{max}}",
						confirm: "Agregar",
						remove: "Eliminar",
						confirmRemove: {
							title: "¿Eliminar combo del servicio?",
							message: "Las selecciones de este combo se descartarán.",
							confirm: "Eliminar",
						},
					},
					info: {
						title: "Ingresa la información del nuevo servicio",
						fields: {
							name: {
								label: "Nombre del grupo (opcional)",
								placeholder: "Ej.: Catering 1",
							},
							serviceType: {
								label: "Tipo de servicio",
								placeholder: "Selecciona",
							},
							serviceFormat: {
								label: "Formato",
								placeholder: "Selecciona",
							},
							numberOfPeople: {
								label: "Cantidad de personas",
								placeholder: "00",
							},
							location: {
								label: "Local o stand",
								placeholder: "Ej. 'Sala 5'",
							},
							periodMode: {
								label: "Agregar horario por",
								datetime: "Fecha y hora",
								duration: "Duración",
							},
							dates: {
								label: "Fechas",
								placeholder: "DD/MM/AAAA",
							},
							startTime: {
								label: "Hora inicial",
								placeholder: "00:00",
							},
							endTime: {
								label: "Hora final",
								placeholder: "00:00",
							},
							period: {
								add: "Agregar período",
								removeAria: "Eliminar período {{index}}",
							},
							duration: {
								label: "Horario",
								placeholder: "00",
								unitLabel: "Unidad",
								units: {
									minutes: "Minutos",
									hours: "Horas",
								},
							},
							notes: {
								label: "Observación (opcional)",
								placeholder: "Ej.: No puede contener fritos ni embutidos.",
							},
						},
						validation: {
							serviceTypeId: { required: "Selecciona el tipo de servicio" },
							serviceFormatId: { required: "Selecciona el formato" },
							numberOfPeople: { required: "Ingresa la cantidad de personas" },
							location: { required: "Ingresa el local o stand" },
							duration: { required: "Ingresa la duración" },
							period: {
								invalidTime: "Horario inválido",
								endBeforeStart: "Debe ser mayor o igual al inicio",
								dateRequired: "Ingresa la fecha",
							},
							notes: { max: "Máximo de {{max}} caracteres" },
						},
					},
				},
			},
			sendInfo: {
				label: "Información de envío",
				action: "Revisar y enviar propuesta",
				title: "Revisar y enviar propuesta",
				description: "Revisa los datos y envía la propuesta al cliente.",
				submit: "Revisar y enviar",
				previewEmail: "Previsualizar correo",
				confirm: {
					title: "Revisa antes de confirmar el envío",
					clientLabel: "Cliente",
					eventStart: "{{date}} inicio",
					daysTotal_one: "{{count}} día total",
					daysTotal_other: "{{count}} días totales",
					investmentLabel: "Inversión total",
					productsCount_one: "{{count}} producto",
					productsCount_other: "{{count}} productos",
					perParticipantSuffix: "por participante",
					perDaySuffix: "por día",
					discountBadge: "Descuento de {{value}}",
					additionBadge: "Adicional de {{value}}",
					attachmentSize: "974.91 KB",
					attachmentName: "Cotización {{proposalName}}.pdf",
					saveAsTemplate: "Guardar como plantilla",
					cancel: "Cancelar",
					send: "Enviar propuesta",
					sendSuccess: "¡Propuesta enviada con éxito!",
					downloadPdf: "Descargar PDF",
					sending: {
						pdf: "Generando PDF...",
						email: "Enviando correo...",
					},
					error: {
						title: "No se pudo generar el PDF.",
						cta: "Inténtalo de nuevo",
						retry: "Intentar de nuevo",
						backToDraft: "Volver al borrador",
					},
				},
				preview: {
					title: "Revisa antes de confirmar el envío",
					back: "Volver",
					subject: "Tu cotización de catering ha llegado",
					attachmentSize: "974.91 KB",
					attachmentName: "Cotización {{proposalName}}.pdf",
					replyCta: "Responder propuesta",
					signOff: "Atentamente,",
					signatureFallback: "Equipo",
				},
				fields: {
					totalValue: "Valor total",
					adjustment: {
						toggle: "Aplicar descuento o adicional",
						valueLabel: "Valor",
						valuePlaceholder: "$ 0.00",
						discount: "Descuento",
						addition: "Adicional",
					},
					mainEmail: {
						label: "Correo principal para envío",
						placeholder: "maria@email.com",
						tooltip: "Correo principal del cliente que recibirá la propuesta.",
					},
					ccEmails: {
						label: "Correos en copia",
						placeholder: "maria@email.com, joao@email.com",
						tooltip: "Separa varios correos con coma.",
					},
					validUntil: {
						label: "Vigencia de la propuesta",
						placeholder: "DD/MM/AAAA",
					},
					bodyText: {
						label: "Texto del cuerpo del correo",
						placeholder: "Ej.: ¡Hola! Te envío la cotización solicitada.",
						counter: "caracteres",
					},
				},
				validation: {
					adjustment: {
						value: {
							required: "Ingresa el valor",
							min: "El valor debe ser mayor que cero",
						},
						type: { required: "Selecciona el tipo de ajuste" },
					},
					mainEmail: {
						required: "Ingresa el correo principal",
						invalid: "Correo inválido",
					},
					ccEmails: { invalid: "Uno o más correos son inválidos" },
					validUntil: {
						required: "Ingresa la vigencia de la propuesta",
						future: "La fecha debe ser futura",
					},
					bodyText: { max: "Máximo de {{max}} caracteres" },
				},
			},
		},
	},
	proposalDetailPage: {
		proposalLabel: "Propuesta #{{id}}",
		status: {
			newResponse: "NUEVA RESPUESTA",
		},
		actions: {
			copyLink: "Copiar enlace",
			favorite: "Favorito",
		},
		sidebar: {
			historyTab: "Historial",
			clientLabel: "Cliente",
			investmentTotal: "Inversión total",
			sendInfoPlaceholder: "Resumen del envío",
			stepLabels: {
				history: "Historial",
				requestDetails: "Detalles de la solicitud",
				services: "Servicios",
				sendInfo: "Envío",
			},
			durationDays_one: "{{count}} día",
			durationDays_other: "{{count}} días",
			servicesCount_one: "{{count}} servicio",
			servicesCount_other: "{{count}} servicios",
			perParticipantSuffix: "por participante",
			perDaySuffix: "por día",
			startDateSuffix: "inicio",
		},
		history: {
			title: "Historial",
			description: "Visualiza tu conversación con el cliente.",
			firstReply: "Primera respuesta el {{date}} a las {{time}}, {{weekday}}",
			sortAria: "Ordenar mensajes",
			loadError: "No se pudo cargar el historial.",
			message: {
				newTag: "NUEVO",
				reply: "Responder",
				sendFailed: "FALLO DE ENVÍO",
				resend: "Reenviar",
				downloadAria: "Descargar adjunto",
			},
		},
		placeholder: "{{section}} en construcción",
	},
};
